export const cities = {
  2: {
    id: 2,
    name_uz: 'Andijon viloyati',
  },
  3: {
    id: 3,
    name_uz: 'Buxoro viloyati',
  },
  4: {
    id: 4,
    name_uz: 'Qashqadaryo viloyati',
  },
  5: {
    id: 5,
    name_uz: 'Qoraqalpog‘iston Respublikasi',
  },
  6: {
    id: 6,
    name_uz: 'Navoiy viloyati',
  },
  7: {
    id: 7,
    name_uz: 'Namangan viloyati',
  },
  8: {
    id: 8,
    name_uz: 'Samarqand viloyati',
  },
  9: {
    id: 9,
    name_uz: 'Sirdaryo viloyati',
  },
  10: {
    id: 10,
    name_uz: 'Farg‘ona viloyati',
  },
  11: {
    id: 11,
    name_uz: 'Toshkent viloyat',
  },
  13: {
    id: 13,
    name_uz: 'Xorazm viloyati',
  },
  14: {
    id: 14,
    name_uz: 'Jizzax viloyati',
  },
  15: {
    id: 15,
    name_uz: 'Surxondaryo viloyati',
  },
  12: {
    id: 12,
    name_uz: 'Toshkent shahri',
  },
}
